import Cookie from 'js-cookie';
import { PermissionLevel, NecessaryCookies, FunctionalCookies, PerformanceCookies, MarketingCookies } from './types';

export function hasCookiePermission(permissionLevel: PermissionLevel) {
  try {
    // TODO: For some reason i need to cast the known cookies array. Ask for help on this one.
    // const knownCookies = {
    //   necessary: Object.values(NecessaryCookies),
    //   functional: Object.values(FunctionalCookies),
    //   performance: Object.values(PerformanceCookies),
    //   marketing: Object.values(MarketingCookies),
    // };
    // const permissionLevelCookies =  knownCookies[permissionLevel] as string[]
    // return permissionLevelCookies.map((c) => Cookie.get(c) === 'allow').includes(true);
    switch (permissionLevel) {
      case 'necessary':
        return Object.values(NecessaryCookies)
          .map((c) => Cookie.get(c) === 'allow')
          .includes(true);

      case 'functional':
        return Object.values(FunctionalCookies)
          .map((c) => Cookie.get(c) === 'allow')
          .includes(true);

      case 'performance':
        return Object.values(PerformanceCookies)
          .map((c) => Cookie.get(c) === 'allow')
          .includes(true);

      case 'marketing':
        return Object.values(MarketingCookies)
          .map((c) => Cookie.get(c) === 'allow')
          .includes(true);

      default:
        return false;
    }
  } catch (error) {
    // return false on default
    return false;
  }
}
